import React from 'react';
import Icons from '@shared/config/constants/Icons';

const HeaderTV = () => {
  return (
    <div className="tv-header">
      <img src={Icons.ic_viplogo_tv} alt="VUZ logo" />
    </div>
  );
};

export { HeaderTV };
